export default __webpack_public_path__ + "static/media/8.beba7ca8.png";